import { Vue } from "vue-property-decorator"
import { commonObjectState } from "~/state/object"
import { IObjectState } from "~/state/types"
import { NewRequester } from "~/core/Requester"
import ObjectHelper from "~/utils/ObjectHelper"

interface ILandingPageState {
  landingPageDetail: IObjectState<any>
}

export const prefix = "landingpage/landingpage"

export const state = (): ILandingPageState => ({
  landingPageDetail: commonObjectState(),
})
export const getters = {
  getDetail: (state: any) => (): any => {
    return state?.shortURLDetail?.data || {}
  },
}

export const mutations = {
  updateDetail: (state: ILandingPageState, data) => {
    Vue.set(state, "landingPageDetail", data)
  },
}

export const actions = {
  getDetail: async ({ commit, state }, data) => {
    const path = `updateDetail`
    try {
      commit(path, ObjectHelper.toLoadingStatus(state.landingPageDetail))
      const response = await NewRequester.get<any>(data.url, { ...data })
      commit(
        path,
        ObjectHelper.toObjSuccessStatus(state.landingPageDetail, response.data)
      )
    } catch (e: any) {
      commit(
        path,
        ObjectHelper.toErrorStatus(
          state.landingPageDetail,
          e.response?.data || e
        )
      )
    }
  },
}
